/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespStorytellingTab_storyTellingTab = {
    readonly smallImage: string | null;
    readonly mainImage: string | null;
    readonly mainVideo: string | null;
    readonly supplementaryEditorial: {
        readonly totalResults: number | null;
    } | null;
    readonly relatedCreators: ReadonlyArray<{
        readonly __typename: string;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingText_storyTellingTab" | "PdpSharedStorytellingRelatedContent_storyTellingTab" | "PdpSharedStorytellingMainMedia_storyTellingTab" | "PdpSharedStorytellingShopAllLink_storyTellingTab">;
    readonly " $refType": "PdpRespStorytellingTab_storyTellingTab";
};
export type PdpRespStorytellingTab_storyTellingTab$data = PdpRespStorytellingTab_storyTellingTab;
export type PdpRespStorytellingTab_storyTellingTab$key = {
    readonly " $data"?: PdpRespStorytellingTab_storyTellingTab$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespStorytellingTab_storyTellingTab">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespStorytellingTab_storyTellingTab",
  "type": "StoryTellingTab",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "smallImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainImage",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "mainVideo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "supplementaryEditorial",
      "storageKey": null,
      "args": null,
      "concreteType": "WordpressArticlesType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "relatedCreators",
      "storageKey": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "__typename",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespStorytellingText_storyTellingTab",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingRelatedContent_storyTellingTab",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingMainMedia_storyTellingTab",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedStorytellingShopAllLink_storyTellingTab",
      "args": null
    }
  ]
};
(node as any).hash = 'a2eeedfcff794228b83dda87082fa214';
export default node;
